import { components, ClearIndicatorProps, GroupBase } from "react-select";
import CrossCircleFilledIcon from "app/icons/navigation/CrossCircleFilledIcon";
import { ICON_SIZES } from "app/constants";

const ClearIndicator = <OptionType,>(
	props: ClearIndicatorProps<OptionType, false, GroupBase<OptionType>>
) => (
	<components.ClearIndicator {...props}>
		<CrossCircleFilledIcon size={ICON_SIZES.MD} />
	</components.ClearIndicator>
);

export { ClearIndicator };
